// extracted by mini-css-extract-plugin
export default {"currency__input":"CurrencyInput_currency__input__MrBpN"};